module.exports = __webpack_public_path__ + "img/带钢全景会员.6e741b2e.png";